//import ReturnReason,{SubReason} from './ReturnReason'
//import React from 'react';
//import ShipInstructionsEmail from '../Components/ShipInstructionsEmail.js'
import { GENERIC_ERROR_MESSAGE, EmailShipInstructionsPayload } from './ReturnEmailData';

export default class RmaLogic {
    // // class methods
    // constructor() {


      
    // }
   
    public findOrderForTracking = async (orderId:string) => {

        var pl={
            orderId:orderId
        }
        var r = await this.PostToFunc('TryLoadPackageTrackingHistory',pl)
        return r
    }

    public findOrder = async (orderId:string, zip:string,mode:string="Live",uip:string="") => {

        var pl = {
            OrderNumber:orderId,
            PostalCode:zip,
            Mode:mode,
            UIP:uip
        }
        var r = await this.PostToFunc('TryLoadOrder',pl)
        
        return r
    }

    GetFromFunc = async (url:string, payload:object) => {
        let results = {};
        await fetch('/apps/rma/Func/V2/RMA/'+url, {
                method: 'GET',
                headers: {
                    Accept: 'application/json'
                }
            })
            .then(this.handleResponse)
            .then(json => results = json)
            .catch(error => {
                console.log("Error in GetFromFunc :" + error);
                console.log("url: " + url);
                return Promise.reject(error);
            });
        //console.log(res.status + ' - ' + res.statusText);
        //const json = await res.json();
        await results
        console.log("PostToFunc Results:");
        console.log(results);
    
        return results;
    };

    PostToFunc = async (url:string, payload:object) => {
        let results = {};
        await fetch('/apps/rma/Func/V2/RMA/'+url, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            })
            .then(this.handleResponse)
            .then(json => results = json)
            .catch(error => {
                console.log("Error in postToFunc :" + error);
                console.log("url: " + url);
                return Promise.reject(error);
            });
        await results
        console.log("PostToFunc Results:");
        console.log(results);
    
        return results;
    };

    handleResponse= (response:Response)=> {
        const parseBody = async () => {
            const text = await response.text();
            if (!text || !text.trim()) {
                return {};
            }
            try {
                return JSON.parse(text);
            } catch {
                console.log('Non-JSON API response');
                return { message: GENERIC_ERROR_MESSAGE };
            }
        };

        return parseBody()
            .then((json) => {
                if (!response.ok) {
                    console.log('API request failed', response.status, response.statusText);
                    return Promise.reject({
                        message: GENERIC_ERROR_MESSAGE,
                        status: response.status,
                    });
                }
                return json;
            });
    }

    postEmailShipInstructions = async (payload: EmailShipInstructionsPayload) => {
        if (!payload.CustomerEmail || !payload.OrderNumber || !payload.EmailBody || !payload.ShippingInstructionsLink) {
            return { success: false, data: null };
        }
        try {
            const data = await this.PostToFunc('EmailShipInstructions', payload);
            return { success: true, data };
        } catch (error) {
            console.log('EmailShipInstructions failed');
            console.log(error);
            return { success: false, data: null };
        }
    };

    emailShipInstructions=async (orderNumber:string,zip:string) => {
        //const statusPageUrl = `https://www.braceability.com/pages/returns?orderId=${orderNumber}&postalCode=${zip}`;

        // let emailBody = <ShipInstructionsEmail
        // statusPageUrl={statusLinkRef}
        // returnOrderNumber:{orderNumber} />
        
        await this.stall(1000)
        // await util.PostToFunc(`SendShipInstructions?uip=${curState.userIp}`, {
        //     CustomerEmail: curState.customerEmail,
        //     OrderNumber: curState.returnOrder.number,
        //     EmailBody: emailBody,
        //     ShippingInstructionsLink: curState.shippingInstructionsLink,
        //     OrderId: curState.returnOrder.id
        // })
    }



 

    

    private  stall = async (stallTime = 1000) => {
        await new Promise(resolve => setTimeout(resolve, stallTime));
    }

}

// public mockfindOrder = async (orderId:number, zip:string) => {

//     await this.stall();
//     var retVal= {
//         rootOriginOrderId: 0,
//         originOrderId: 0,
//         originReference: '',
//         isInternational: false,
//         untaxedAmount: 0,
//         taxedAmount: 0,
//         lines: [
//             {
//                 uiid: 'a',
//                 originLineId: 0,
//                 weight: 1,
//                 isExchange: true,
//                 isReturn: false,
//                 comments: '',
//                 productTitle: 'Osgood Schlatters Knee Brace (S)',
//                 sku: '03K14-S',
//                 size: 'S',
//                 price: 39.99,
//                 state: 'NotEligible',
//                 eligibleDate: new Date(2019, 9, 20).toLocaleDateString(),
//                 reason: '',
//                 reasonId: 0,
//                 option1: -1,
//                 option2: -1,
//                 subReasonId: 0,
//                 newSize: 'M',
//                 trackingUrl: 'https://tools.usps.com/go/TrackConfirmAction?tLabels=9401910200881138681792',
//                 instructionsUrl: 'https://rmafunctions.azurewebsites.net/api/ReprintLabel?file=SO536066-20190924213711770.pdf',
//                 productImage: {
//                     src: 'https://cdn.shopify.com/s/files/1/0011/7958/2517/products/03k1401-osgood-schlatters-disease-knee-brace.jpg?v=1551908812',
//                     alt: ''
//                 },
//                 sizeChartImage: {
//                     src: 'https://cdn.shopify.com/s/files/1/0011/7958/2517/products/10k01-bariatric-knee-brace-sizing-05-23-2019.jpg',
//                     alt: 'sizing chart for hinged plus size knee support'
//                 },
//                 shopifyVariantId: 0,
//                 variants: [
//                     {
//                         id: 7695132590133,
//                         product_id: 623896297525,
//                         fulfil_product_id: 22,
//                         title: "Right / S",
//                         sku: "11F0201SR",
//                         position: 1,
//                         option1: "Right",
//                         option2: "S",
//                         option3: null,
//                         isFinalSaleItem: false
//                     },
//                     {
//                         id: 7695132655669,
//                         product_id: 623896297525,
//                         fulfil_product_id: 22,
//                         title: "Right / M",
//                         price: "34.99",
//                         sku: "11F0201MR",
//                         position: 2,
//                         option1: "Right",
//                         option2: "M",
//                         option3: null,
//                         isFinalSaleItem: false
//                     },
//                     {
//                         id: 7695132721205,
//                         product_id: 623896297525,
//                         fulfil_product_id: 22,
//                         title: "Right / L",
//                         price: "34.99",
//                         sku: "11F0201LR",
//                         position: 3,
//                         inventory_policy: "deny",
//                         compare_at_price: "49.99",
//                         fulfillment_service: "manual",
//                         inventory_management: "shopify",
//                         option1: "Right",
//                         option2: "L",
//                         option3: null,

//                         isFinalSaleItem: false
//                     },
//                     {
//                         id: 7695132557365,
//                         product_id: 623896297525,
//                         fulfil_product_id: 22,
//                         title: "Left / S",
//                         price: "34.99",
//                         sku: "11F0201SL",
//                         position: 4,
//                         inventory_policy: "deny",
//                         compare_at_price: "49.99",
//                         fulfillment_service: "manual",
//                         inventory_management: "shopify",
//                         option1: "Left",
//                         option2: "S",
//                         option3: null,

//                         isFinalSaleItem: false
//                     },
//                     {
//                         id: 7695132622901,
//                         product_id: 623896297525,
//                         fulfil_product_id: 22,
//                         title: "Left / M",
//                         price: "34.99",
//                         sku: "11F0201ML",
//                         position: 5,
//                         inventory_policy: "deny",
//                         compare_at_price: "49.99",
//                         fulfillment_service: "manual",
//                         inventory_management: "shopify",
//                         option1: "Left",
//                         option2: "M",
//                         option3: null,

//                         isFinalSaleItem: false
//                     },
//                     {
//                         id: 7695132688437,
//                         product_id: 623896297525,
//                         fulfil_product_id: 22,
//                         title: "Left / L",
//                         price: "34.99",
//                         sku: "11F0201LL",
//                         position: 6,
//                         inventory_policy: "deny",
//                         compare_at_price: "49.99",
//                         fulfillment_service: "manual",
//                         inventory_management: "shopify",
//                         option1: "Left",
//                         option2: "L",
//                         option3: null,

//                         isFinalSaleItem: false
//                     }
//                 ],
//                 options: [
//                     {
//                         id: 940731957301,
//                         product_id: 623896297525,
//                         name: "Right or Left",
//                         position: 1,
//                         values: [
//                             "Right",
//                             "Left"
//                         ]
//                     },
//                     {
//                         id: 940731924533,
//                         product_id: 623896297525,
//                         name: "Size",
//                         position: 2,
//                         values: [
//                             "S",
//                             "M",
//                             "L"
//                         ]
//                     }
//                 ],
//             },
//             {
//                 uiid: 'b',
//                 weight: 1,
//                 isExchange: false,
//                 isReturn: false,
//                 originLineId: 0,
//                 comments: '',
//                 productTitle: 'Cold / Hot Therapy Gel Pack (9" x 11")',
//                 sku: '11B01',
//                 price: 12.99,
//                 state: 'Eligible',
//                 eligibleDate: new Date(2019, 10, 19).toLocaleDateString(),
//                 productImage: {
//                     src: 'https://cdn.shopify.com/s/files/1/0011/7958/2517/products/11b01-braceability-hot-cold-gel-pack.jpg?v=1545409820',
//                     alt: ''
//                 },
//                 sizeChartImage: {
//                     src: 'https://cdn.shopify.com/s/files/1/0011/7958/2517/products/10k01-bariatric-knee-brace-sizing-05-23-2019.jpg',
//                     alt: 'sizing chart for hinged plus size knee support'
//                 },
//                 option1: -1,
//                 option2: -1,
//                 subReasonId: 0,
//                 reasonId: 0,
//                 shopifyVariantId: 0,
//                 variants: [
//                     {
//                         id: 7695132590133,
//                         product_id: 623896297525,
//                         fulfil_product_id: 22,
//                         title: "Right / S",
//                         sku: "11F0201SR",
//                         position: 1,
//                         option1: "Right",
//                         option2: "S",
//                         option3: null,
//                         isFinalSaleItem: false
//                     },
//                     {
//                         id: 7695132655669,
//                         product_id: 623896297525,
//                         fulfil_product_id: 22,
//                         title: "Right / M",
//                         price: "34.99",
//                         sku: "11F0201MR",
//                         position: 2,
//                         option1: "Right",
//                         option2: "M",
//                         option3: null,
//                         isFinalSaleItem: false
//                     },
//                     {
//                         id: 7695132721205,
//                         product_id: 623896297525,
//                         fulfil_product_id: 22,
//                         title: "Right / L",
//                         price: "34.99",
//                         sku: "11F0201LR",
//                         position: 3,
//                         inventory_policy: "deny",
//                         compare_at_price: "49.99",
//                         fulfillment_service: "manual",
//                         inventory_management: "shopify",
//                         option1: "Right",
//                         option2: "L",
//                         option3: null,

//                         isFinalSaleItem: false
//                     },
//                     {
//                         id: 7695132557365,
//                         product_id: 623896297525,
//                         fulfil_product_id: 22,
//                         title: "Left / S",
//                         price: "34.99",
//                         sku: "11F0201SL",
//                         position: 4,
//                         inventory_policy: "deny",
//                         compare_at_price: "49.99",
//                         fulfillment_service: "manual",
//                         inventory_management: "shopify",
//                         option1: "Left",
//                         option2: "S",
//                         option3: null,

//                         isFinalSaleItem: false
//                     },
//                     {
//                         id: 7695132622901,
//                         product_id: 623896297525,
//                         fulfil_product_id: 22,
//                         title: "Left / M",
//                         price: "34.99",
//                         sku: "11F0201ML",
//                         position: 5,
//                         inventory_policy: "deny",
//                         compare_at_price: "49.99",
//                         fulfillment_service: "manual",
//                         inventory_management: "shopify",
//                         option1: "Left",
//                         option2: "M",
//                         option3: null,

//                         isFinalSaleItem: false
//                     },
//                     {
//                         id: 7695132688437,
//                         product_id: 623896297525,
//                         fulfil_product_id: 22,
//                         title: "Left / L",
//                         price: "34.99",
//                         sku: "11F0201LL",
//                         position: 6,
//                         inventory_policy: "deny",
//                         compare_at_price: "49.99",
//                         fulfillment_service: "manual",
//                         inventory_management: "shopify",
//                         option1: "Left",
//                         option2: "L",
//                         option3: null,

//                         isFinalSaleItem: false
//                     }
//                 ],
//                 options: [
//                     {
//                         id: 940731957301,
//                         product_id: 623896297525,
//                         name: "Right or Left",
//                         position: 1,
//                         values: [
//                             "Right",
//                             "Left"
//                         ]
//                     },
//                     {
//                         id: 940731924533,
//                         product_id: 623896297525,
//                         name: "Size",
//                         position: 2,
//                         values: [
//                             "S",
//                             "M",
//                             "L"
//                         ]
//                     }
//                 ],
//             },
//             {
//                 uiid: 'c',
//                 weight: 1,
//                 originLineId: 0,
//                 isExchange: false,
//                 isReturn: false,
//                 comments: '',
//                 productTitle: 'Low Back Support Brace-3XL',
//                 sku: '03B02-3XL',
//                 price: 39.99,
//                 state: 'Eligible',
//                 eligibleDate: new Date(2019, 10, 19).toLocaleDateString(),
//                 size: '3XL',
//                 productImage: {
//                     src: 'https://cdn.shopify.com/s/files/1/0011/7958/2517/products/03b0503-sciatica-back-pain-brace-procides_support-and-compression.jpg?v=1536335664',
//                     alt: ''
//                 },
//                 sizeChartImage: {
//                     src: 'https://cdn.shopify.com/s/files/1/0011/7958/2517/products/10k01-bariatric-knee-brace-sizing-05-23-2019.jpg',
//                     alt: 'sizing chart for hinged plus size knee support'
//                 },
//                 option1: -1,
//                 option2: -1,
//                 shopifyVariantId: 0,
//                 subReasonId: 0,
//                 reasonId: 0,
//                 variants: [
//                     {
//                         id: 7695132590133,
//                         product_id: 623896297525,
//                         fulfil_product_id: 22,
//                         title: "Right / S",
//                         sku: "11F0201SR",
//                         position: 1,
//                         option1: "Right",
//                         option2: "S",
//                         option3: null,
//                         isFinalSaleItem: false
//                     },
//                     {
//                         id: 7695132655669,
//                         product_id: 623896297525,
//                         fulfil_product_id: 22,
//                         title: "Right / M",
//                         price: "34.99",
//                         sku: "11F0201MR",
//                         position: 2,
//                         option1: "Right",
//                         option2: "M",
//                         option3: null,
//                         isFinalSaleItem: false
//                     },
//                     {
//                         id: 7695132721205,
//                         product_id: 623896297525,
//                         fulfil_product_id: 22,
//                         title: "Right / L",
//                         price: "34.99",
//                         sku: "11F0201LR",
//                         position: 3,
//                         inventory_policy: "deny",
//                         compare_at_price: "49.99",
//                         fulfillment_service: "manual",
//                         inventory_management: "shopify",
//                         option1: "Right",
//                         option2: "L",
//                         option3: null,

//                         isFinalSaleItem: false
//                     },
//                     {
//                         id: 7695132557365,
//                         product_id: 623896297525,
//                         fulfil_product_id: 22,
//                         title: "Left / S",
//                         price: "34.99",
//                         sku: "11F0201SL",
//                         position: 4,
//                         inventory_policy: "deny",
//                         compare_at_price: "49.99",
//                         fulfillment_service: "manual",
//                         inventory_management: "shopify",
//                         option1: "Left",
//                         option2: "S",
//                         option3: null,

//                         isFinalSaleItem: false
//                     },
//                     {
//                         id: 7695132622901,
//                         product_id: 623896297525,
//                         fulfil_product_id: 22,
//                         title: "Left / M",
//                         price: "34.99",
//                         sku: "11F0201ML",
//                         position: 5,
//                         inventory_policy: "deny",
//                         compare_at_price: "49.99",
//                         fulfillment_service: "manual",
//                         inventory_management: "shopify",
//                         option1: "Left",
//                         option2: "M",
//                         option3: null,

//                         isFinalSaleItem: false
//                     },
//                     {
//                         id: 7695132688437,
//                         product_id: 623896297525,
//                         fulfil_product_id: 22,
//                         title: "Left / L",
//                         price: "34.99",
//                         sku: "11F0201LL",
//                         position: 6,
//                         inventory_policy: "deny",
//                         compare_at_price: "49.99",
//                         fulfillment_service: "manual",
//                         inventory_management: "shopify",
//                         option1: "Left",
//                         option2: "L",
//                         option3: null,

//                         isFinalSaleItem: false
//                     }
//                 ],
//                 options: [
//                     {
//                         id: 940731957301,
//                         product_id: 623896297525,
//                         name: "Right or Left",
//                         position: 1,
//                         values: [
//                             "Right",
//                             "Left"
//                         ]
//                     },
//                     {
//                         id: 940731924533,
//                         product_id: 623896297525,
//                         name: "Size",
//                         position: 2,
//                         values: [
//                             "S",
//                             "M",
//                             "L"
//                         ]
//                     }
//                 ],
//             },
//             {
//                 uiid: 'd',
//                 weight: 1,
//                 originLineId: 0,
//                 isExchange: true,
//                 isReturn: false,
//                 comments: '',
//                 productTitle: 'Osgood Schlatters Knee Brace (S)',
//                 sku: '03K14-S',
//                 size: 'S',
//                 price: 39.99,
//                 state: 'Pending',
//                 reason: 'Wrong Size / Did Not Fit : Too Small',
//                 reasonId: 0,
//                 option1: -1,
//                 option2: -1,
//                 subReasonId: 0,
//                 eligibleDate: new Date(2019, 10, 20).toLocaleDateString(),
//                 refundAmount: 39.99,
//                 deniedReason: '',
//                 newSize: 'M',
//                 trackingUrl: 'https://tools.usps.com/go/TrackConfirmAction?tLabels=9401910200881138681792',
//                 instructionsUrl: 'https://rmafunctions.azurewebsites.net/api/ReprintLabel?file=SO536066-20190924213711770.pdf',
//                 productImage: {
//                     src: 'https://cdn.shopify.com/s/files/1/0011/7958/2517/products/03k1401-osgood-schlatters-disease-knee-brace.jpg?v=1551908812',
//                     alt: ''
//                 },
//                 sizeChartImage: {
//                     src: 'https://cdn.shopify.com/s/files/1/0011/7958/2517/products/10k01-bariatric-knee-brace-sizing-05-23-2019.jpg',
//                     alt: 'sizing chart for hinged plus size knee support'
//                 },
//                 shopifyVariantId: 0,
//                 variants: [],
//                 options: [],
//             },
//             {
//                 uiid: 'e',
//                 weight: 1,
//                 originLineId: 0,
//                 isExchange: true,
//                 isReturn: false,
//                 comments: '',
//                 productTitle: 'Osgood Schlatters Knee Brace (S)',
//                 sku: '03K14-S',
//                 size: 'S',
//                 price: 39.99,
//                 state: 'Denied',
//                 reason: 'Wrong Size / Did Not Fit : Too Small',
//                 deniedImages: ['https://babotstorage.blob.core.windows.net/receive-damaged-image/Damaged-Return-SO544701-IMG_5648-20191010102631395.JPG',
//                     'https://babotstorage.blob.core.windows.net/receive-damaged-image/Damaged-Return-SO544701-IMG_5647-20191010102635519.JPG',
//                     'https://babotstorage.blob.core.windows.net/receive-damaged-image/Damaged-Return-SO544701-IMG_5646-20191010102638265.JPG',
//                     'https://babotstorage.blob.core.windows.net/receive-damaged-image/Damaged-Return-SO544701-IMG_5645-20191010102640621.JPG',
//                     'https://babotstorage.blob.core.windows.net/receive-damaged-image/Damaged-Return-SO544701-IMG_5644-20191010102643528.JPG'],
//                 reasonId: 0,
//                 option1: -1,
//                 option2: -1,
//                 subReasonId: 0,
//                 eligibleDate: new Date(2019, 10, 20).toLocaleDateString(),
//                 refundAmount: 39.99,
//                 deniedReason: 'Smoke Smell or Other Odor',
//                 newSize: 'M',
//                 trackingUrl: 'https://tools.usps.com/go/TrackConfirmAction?tLabels=9401910200881138681792',
//                 instructionsUrl: 'https://rmafunctions.azurewebsites.net/api/ReprintLabel?file=SO536066-20190924213711770.pdf',
//                 productImage: {
//                     src: 'https://cdn.shopify.com/s/files/1/0011/7958/2517/products/03k1401-osgood-schlatters-disease-knee-brace.jpg?v=1551908812',
//                     alt: ''
//                 },
//                 sizeChartImage: {
//                     src: 'https://cdn.shopify.com/s/files/1/0011/7958/2517/products/10k01-bariatric-knee-brace-sizing-05-23-2019.jpg',
//                     alt: 'sizing chart for hinged plus size knee support'
//                 },
//                 shopifyVariantId: 0,
//                 variants: [],
//                 options: [],
//             },
//             {
//                 uiid: 'f',
//                 weight: 1,
//                 originLineId: 0,
//                 isExchange: false,
//                 isReturn: false,
//                 comments: '',
//                 productTitle: 'Osgood Schlatters Knee Brace (S)',
//                 sku: '03K14-S',
//                 size: 'S',
//                 price: 39.99,
//                 state: 'Eligible',
//                 reason: '',
//                 reasonId: 0,
//                 option1: -1,
//                 option2: -1,
//                 subReasonId: 0,
//                 eligibleDate: new Date(2019, 9, 20).toLocaleDateString(),
//                 refundAmount: 39.99,
//                 deniedReason: 'Smoke Smell or Other Odor',
//                 newSize: '',
//                 trackingUrl: 'https://tools.usps.com/go/TrackConfirmAction?tLabels=9401910200881138681792',
//                 instructionsUrl: 'https://rmafunctions.azurewebsites.net/api/ReprintLabel?file=SO536066-20190924213711770.pdf',
//                 productImage: {
//                     src: 'https://cdn.shopify.com/s/files/1/0011/7958/2517/products/03k1401-osgood-schlatters-disease-knee-brace.jpg?v=1551908812',
//                     alt: ''
//                 },
//                 sizeChartImage: {
//                     src: 'https://cdn.shopify.com/s/files/1/0011/7958/2517/products/10k01-bariatric-knee-brace-sizing-05-23-2019.jpg',
//                     alt: 'sizing chart for hinged plus size knee support'
//                 },
//                 shopifyVariantId: 0,
//                 variants: [],
//                 options: [],
//             },
//             {
//                 uiid: 'g',
//                 weight: 1,
//                 originLineId: 0,
//                 isExchange: false,
//                 isReturn: false,
//                 comments: '',
//                 productTitle: 'Osgood Schlatters Knee Brace (S)',
//                 sku: '03K14-S',
//                 size: 'S',
//                 price: 39.99,
//                 state: 'Refunded',
//                 reason: '',
//                 reasonId: 0,
//                 option1: -1,
//                 option2: -1,
//                 subReasonId: 0,
//                 eligibleDate: new Date(2019, 9, 20).toLocaleDateString(),
//                 refundAmount: 35.99,
//                 deniedReason: 'Smoke Smell or Other Odor',
//                 newSize: '',
//                 trackingUrl: 'https://tools.usps.com/go/TrackConfirmAction?tLabels=9401910200881138681792',
//                 instructionsUrl: 'https://rmafunctions.azurewebsites.net/api/ReprintLabel?file=SO536066-20190924213711770.pdf',
//                 productImage: {
//                     src: 'https://cdn.shopify.com/s/files/1/0011/7958/2517/products/03k1401-osgood-schlatters-disease-knee-brace.jpg?v=1551908812',
//                     alt: ''
//                 },
//                 sizeChartImage: {
//                     src: 'https://cdn.shopify.com/s/files/1/0011/7958/2517/products/10k01-bariatric-knee-brace-sizing-05-23-2019.jpg',
//                     alt: 'sizing chart for hinged plus size knee support'
//                 },
//                 shopifyVariantId: 0,
//                 variants: [],
//                 options: [],
//             },
//             {
//                 uiid: 'h',
//                 weight: 1,
//                 originLineId: 0,
//                 isExchange: false,
//                 isReturn: false,
//                 comments: '',
//                 productTitle: 'Osgood Schlatters Knee Brace (S)',
//                 sku: '03K14-S',
//                 size: 'S',
//                 price: 39.99,
//                 state: 'Initiated',
//                 returnTrackingUrl: 'https://tools.usps.com/go/TrackConfirmAction?tLabels=9402010200830367976557',
//                 shipInstructionsUrl: 'https://rmafunctions.azurewebsites.net/api/ReprintLabel?file=SO550188-20191010203838366.pdf',
//                 reason: '',
//                 reasonId: 0,
//                 option1: -1,
//                 option2: -1,
//                 subReasonId: 0,
//                 eligibleDate: new Date(2019, 9, 20).toLocaleDateString(),
//                 refundAmount: 35.99,
//                 deniedReason: 'Smoke Smell or Other Odor',
//                 newSize: '',
//                 trackingUrl: 'https://tools.usps.com/go/TrackConfirmAction?tLabels=9401910200881138681792',
//                 instructionsUrl: 'https://rmafunctions.azurewebsites.net/api/ReprintLabel?file=SO536066-20190924213711770.pdf',
//                 productImage: {
//                     src: 'https://cdn.shopify.com/s/files/1/0011/7958/2517/products/03k1401-osgood-schlatters-disease-knee-brace.jpg?v=1551908812',
//                     alt: ''
//                 },
//                 sizeChartImage: {
//                     src: 'https://cdn.shopify.com/s/files/1/0011/7958/2517/products/10k01-bariatric-knee-brace-sizing-05-23-2019.jpg',
//                     alt: 'sizing chart for hinged plus size knee support'
//                 },
//                 shopifyVariantId: 0,
//                 variants: [],
//                 options: [],
//             }
//         ]
//     }
//     return retVal
// }
